export function messageFromError(error: unknown, t: (key: string) => string) {
  console.log("error", error);
  if (error && typeof error === "object" && "code" in error && error.code) {
    const translated = t(String(error.code));
    // If translation exists and not same as key (i18next fallback detection)
    if (translated && translated !== error.code) {
      return translated;
    }
  }
  const errorObject = error as { message: string };
  if (errorObject.message) {
    return errorObject.message;
  }
  return String(error);
}

export const getCodeMessageFromError = (error: unknown) => {
  let message = '';
  let code = '';
  if (error && typeof error === "object" && "code" in error && error.code) {
    code = String(error.code);
  }
  if (error && typeof error === "object" && "message" in error && error.message) {
    message = String(error.message);
  }
  return { message, code };
}

export const codeFromError = (error: unknown) => {
  if (error && typeof error === "object" && "code" in error && error.code) {
    return String(error.code);
  }
  return null;
}